"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MergePatchConverter {
    /**
     * Convert object to the required mapping based on the object's properties.
     *
     * @param object TargetModel
     * @param mapping {}
     *
     * @returns {}
     */
    convert(object, mapping) {
        let data = [];
        for (let key in mapping) {
            data[key] = mapping[key].call(object);
        }
        return data;
    }
}
exports.default = MergePatchConverter;
